module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-header02.c3f844e0.jpg";